import { useLayoutEffect, useRef } from 'react';

// Mirrors the latest rendered value into a stable ref, so handlers that read it can
// stay referentially stable — keeping caller-supplied callbacks out of memo deps that
// would otherwise rebuild TanStack column cells and remount an open inline editor.
// The write is a layout effect, not a passive one: it lands before paint, so a click
// arriving straight after a re-render cannot read the previous value.
export function useLatestRef<T>(value: T) {
    const ref = useRef(value);
    useLayoutEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
